import React from 'react';

import fetch from './../fetch';

const queryEnumByName = (enumName) => {
    return fetch.post('platform/code/academicGuidance/queryEnumByName', enumName)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.value,
                label: d.label
            }
        });
    });
}

export default {
 
    queryEnumByName
}